/**
 * @prettier
 */
var ConsumerExternalProfileWS = require("../ws/ConsumerExternalProfileWS");
var AbstractWS = require("./AbstractWS");
var tracingTransaction = require("../helpers/sentry").tracingTransaction

function EventsWS(viewModel) {
  var self = this;
  // Predicate self Web Service handler on the Abstract class of a Web
  // Service handler. self establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(self, arguments);

  self.name = "EventsWS";

  self.lastEvent = null;

  self.queueStatusMap = {
    ACTIVATE: "ACTIVE",
    CLOSED: "CLOSED",
    DEACTIVATE: "INACTIVE",
  };
}

EventsWS.prototype = Object.create(AbstractWS.prototype);
EventsWS.prototype.constructor = EventsWS;

/**
 * Determines if the event ID matches the current queue id
 *
 * @method eventIsForSelectedQueues
 * @param {String} sEventId Event ID from the WebSocket event
 * @returns {Boolean}
 */
EventsWS.prototype.eventIsForSelectedQueues = function (eventId) {
  var parsedEventId = Number(eventId);
  return (
    !isNaN(parsedEventId) &&
    this.parent.selectedQueueIds().indexOf(parsedEventId) > -1
  );
};

/**
 * Splits the messages received and hands each one off for processing
 *
 * @method handleMessage
 * @param {String} evt
 * @returns none
 */
EventsWS.prototype.handleMessage = function (evt) {
  var self = this;
  var evts = evt.trim().split("\n");

  evts.forEach(function (e) {
    self.conlog(e);
    self.processMessage(e);
  });
};

/**
 * Proceesses individual event messages into actionable items
 *
 * @method processMessage
 * @param {String} evt
 * @returns none
 */
EventsWS.prototype.processMessage = function (evt) {
  var transaction = tracingTransaction({ name: "qless.cec.event" })
  var span = null;

  var self = this;
  var parts = evt
    .replace(/[}{]/g, "")
    .replace('"event":', "")
    .trim()
    .split(" ");
  var evtType = parts[0];

  if (transaction) {
    span = transaction.startChild({ op: 'qless.cec.event.process', description: evtType })
  }

  var q = self.parent.queuesWS.getQueueById(parts[1]);

  self.lastEvent = evt.data;

  self.parent.listVM.update();

  // Look for recognized event types

  // These events can be processed for any queue
  if (["ACTIVATE", "CLOSED", "DEACTIVATE"].indexOf(evtType) > -1) {
    self.parent.listVM.update();

    // If its a simple status change, simply update the queue state
    if (self.queueStatusMap[evtType] != null) {
      // Find the queue from the collection of known queues
      q = self.parent.queuesWS.getQueueById(parts[1]);

      // If it was found, set the state
      if (q) {
        q.state(self.queueStatusMap[evtType]);
        self.parent.queueSelectionVM.updateQueueList(q.id);
      }
    }
  } else if ("CHANGE" === evtType) {
    // event[1] sourceQueueId
    // event[2] destinationQueueId
    // event[3] sessionId
    if (self.eventIsForSelectedQueues(parts[2])) {
      // if (recentlyArrived.expanded && canvas.allowParallelServiceTransactions) {
      // 	activeServiceTransactionsWS.doRequest();
      // }
      // if (!canvas.allowParallelServiceTransactions && canvas.currentlyServicingSpot != null && canvas.currentlyServicingSpot.getAttr("sessionId") == event[3] && canvas.currentlyServicingQueueId == event[1]) {
      // 	canvas.setAttribute("currentlyServicingQueueId", event[2]);
      // }
    }
  }

  // Fires when a new Consumer joins the line
  else if ("ENTER" === evtType) {
    if (q) { // There are some unwanted cases when there's no queue associated with the event... We just skip those
      self.parent.listVM.update();
      q.enter(parts[2]);
      self.parent.onQueueEnter(q);
      self.parent.queueSelectionVM.updateQueueList(parts[1]);
    }
  } else if ("MOVE" === evtType) {
    // event[1] sourceQueueId
    // event[2] destinationQueueId
    // event[3] sessionId

    self.parent.listVM.update();

    var destQueue = self.parent.queuesWS.getQueueById(parts[2]);
    var srcQueue = self.parent.queuesWS.getQueueById(parts[1]);

    if (destQueue) {
      destQueue.updateAllSpots();
    }

    if (srcQueue) {
      srcQueue.updateAllSpots();
    }

    self.parent.queueSelectionVM.updateQueueList(parts[1]);
    self.parent.queueSelectionVM.updateQueueList(parts[2]);
  } else if ("PHONE_NUMBER_UPDATED" == evtType) {
    var spot = q.spotsWS.getSpotBySessionId(parts[3]);

    if (spot) {
      q.updateAllSpots();
    }
  } 
  else if (["LEAVE", "REDEEM"].indexOf(evtType) > -1) {
    self.parent.queueSelectionVM.updateQueueList(parts[1]);
  }

  // These events will only be processed for the currently selected queue
  if (
    self.eventIsForSelectedQueues(parts[1]) ||
    self.parent.showListView() ||
    self.parent.queueSelectionVM.queueSelectionVisible()
  ) {
    if (
      [
        "APPOINTMENT_APPROVED",
        "APPOINTMENT_CANCELED",
        "APPOINTMENT_CHECKED_IN",
        "APPOINTMENT_FAIL",
        "APPOINTMENT_PENDING",
        "APPOINTMENT_REJECTED",
        "APPOINTMENT_RESCHEDULED",
        "APPOINTMENT_SCHEDULED",
        "APPOINTMENT_SERVED_EARLY",
        "APPOINTMENT_UNCANCELED",
      ].indexOf(evtType) > -1
    ) {
      // refreshAppointmentView();
    } else if ("APPOINTMENT_QUEUED" == evtType) {
      if (q && q.id == Number(parts[1])) {
        // queues[i].setAttribute('refreshAppointmentViewAfterNextSpotsRefresh', true);
        q.updateAllSpots();
      }
    } else if (
      [
        "CALL_AHEAD_UPDATED",
        "CONSUMER_UPDATED",
        "NOTECARD_PRINTED",
        "PARTY_SIZE_UPDATED",
        "TRANSACTION_TYPE_UPDATED",
      ].indexOf(evtType) > -1 ||
      ("REARRANGE" == evtType && parts[5] == "true")
    ) {
      self.parent.listVM.update();

      if (evtType == "CALL_AHEAD_UPDATED" && q.audibleAlertsOnCheckIn) {
        self.parent.playDoorbellForQueue(q.id);
      }

      // 	if ( evtType == 'CALL_AHEAD_UPDATED' && q.appointmentAsCallAhead ) {
      // 		// refreshAppointmentView();
      // 	}

      if (q && q.id == Number(parts[1])) {
        q.updateAllSpots();
      }
    }

    // else if ( ['CALL_STARTED', 'CALL_ENDED'].indexOf( evtType ) > -1 ) {
    // 	var spot = q.spotsWS.getSpotBySessionId( parts[2] );

    // 	if ( spot ) {

    // 		// if (event[0] == 'CALL_STARTED') {
    // 		// 	persons[j].phone.show.doStart();
    // 		// } else {
    // 		// 	persons[j].phone.hide.doStart();
    // 		// }
    // 	}
    // }

    // else if ( 'CHANGE' == evtType ) {
    // 	// event[1] sourceQueueId
    // 	// event[2] destinationQueueId
    // 	// event[3] sessionId

    // 	// if (recentlyArrived.expanded && canvas.allowParallelServiceTransactions) {
    // 	// 	activeServiceTransactionsWS.doRequest();
    // 	// }

    // 	// if (!canvas.allowParallelServiceTransactions && canvas.currentlyServicingSpot != null && canvas.currentlyServicingSpot.getAttr("sessionId") == event[3] && canvas.currentlyServicingQueueId == event[1]) {
    // 	// 	canvas.setAttribute("currentlyServicingQueueId", event[2]);
    // 	// }
    // }

    // else if ( ['CONFIRM', 'UNCONFIRM'].indexOf( evtType ) > -1 ) {
    // 	// if ( util.hasRole( 'ticketTaker.' + q.id ) ) {
    // 	// 	q.getTickets();
    // 	// }
    // }
    else if ("REDEEM" === evtType) {
      self.parent.listVM.update();

      if (q && self.parent.hasRole("ticketTaker." + q.id)) {
        var userId = parts[3];
        var merchantConsumerInfoId = parts[4];

        if (self.parent.authInfoWS.userId() == userId) {
          if (q.consumerExternalProfileId && merchantConsumerInfoId) {
            var consumerExternalProfileWS = new ConsumerExternalProfileWS();
            self.parent.consumerExternalProfileWS.openProfile(
              q.id,
              merchantConsumerInfoId
            );
          }
        }
      }

      if (q) {
        q.updateAllSpots();
      }

    } else if (
      [
        "EXTERNALRESOURCECOUNTUPDATE",
        "QUEUE_DELETED",
        "QUEUE_ENABLED",
        "REFRESH",
      ].indexOf(evtType) > -1
    ) {
      // If a refresh was called for, get the latest spots and called tickets
      if ("REFRESH" == evtType) {
        self.parent.listVM.update();

        //refreshAppointmentView();
        if (q && q.id == Number(parts[1])) {
          q.updateAllSpots();
        }
      }
      // Otherwise, just get new Queues data
      else {
        self.parent.queuesWS.doRequest();
      }
    }

    // else if ( 'MOVE' == evtType ) {
    // 	// event[1] sourceQueueId
    // 	// event[2] destinationQueueId
    // 	// event[3] sessionId

    // 	var destQueue = self.parent.queuesWS.getQueueById( parts[2] ),
    // 	    sessionId = parts[3];

    // 	if ( destQueue ) {
    // 		q.pushBack( sessionId, destQueue );
    // 		// refreshAppointmentView();
    // 	}
    // }
    else if ("PHONE_ENABLED_FOR_KIOSK" == evtType) {
      self.parent.listVM.update();
      self.parent.checkPhoneEnabledWS.doRequest();
    } else if ("PUSHBACK" == evtType) {
      self.parent.listVM.update();
      q.pushBack(parts[2]);
      // refreshAppointmentView();
    }

    // else if ( 'QUEUE_PRIORITIES_UPDATED' == evtType && canvas.useMultiLevelSummoning ) {
    // queuePrioritiesWS.doRequest();
    // }
    else if ("REMOVE" == evtType) {
      // NOTE: Sometimes an event is received for a Queue at a Location that CEC
      // does not have selected.  In that case, we will not have data for the
      // Queue and `getQueueById` will return undefined.
      if (q) {
        q.expiredTicketsWS.doRequest();
      }
    } else if ("EXPIRED" == evtType) {
      q.updateAllSpots();
    }

    // if (recentlyArrived.expanded) {
    // 	recentArrivalsWS.doRequest();
    // }
    // }
    else if (["SERVICE_STARTED", "SERVICE_ENDED"].indexOf(evtType) > -1) {
      self.parent.activeServiceTransactionsWS.doRequest();

      if (self.parent.showListView()) {
        self.parent.listVM.update();
      }
    } else if (["TICKET", "LEAVE"].indexOf(evtType) > -1) {
      console.log("Leave Handler 2", q)

      if (self.parent.showListView()) {
        self.parent.listVM.update();
      } else {
        q.updateAllSpots();
      }

      // NOTE: We check `q` because some Merchants will move Consumers between
      // Queues at **different** Locations. If one employee is managing multiple
      // Locations, and another employee is only managing one, then the CEC with
      // only one of those Locations will not queue data for the other Location.
      // This will cause `getQueueById` to return `undefined`.
      
      if (q && self.parent.hasRole("ticketTaker." + q.id)) {
        //q.setAttribute('refreshAppointmentViewAfterNextSpotsRefresh', true);
        q.leave(parts[2]);
      }
    } else if ("UPDATE" == evtType) {
      var spot = q.spotsWS.getSpotBySessionId(parts[2]);

      if (spot) {
        // spot.statusMsg.show.doStart();
      }
    } else if ("USERS_PERMS_CHANGED" == evtType) {
      // refresh the authInfo roles, if this user matches the one on the event
      // var currentUserId = authInfo.getPointer().xpathQuery('authInfo/@userid');
      // if(currentUserId == event[1]) {
      // 	Debug.debug('Refreshing UI due to USERS_PERMS_CHANGED event: ', event);
      // 	canvas.queues.setAttribute('refreshSpots', true);
      // 	authInfo.setQueryParam('refresh', true);
      // 	authInfo.doRequest();
      // }
    }
  } // END IF
 
  if (span && transaction) {
    span.setStatus("ok")
    span.finish()
    transaction.finish()
  }
};

module.exports = EventsWS;
